var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBronze(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 41,
    viewBox: "0 0 28 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_61_1779)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.9186 9.60465L5.86047 3.15116L12.1395 1.05814V7.27907C12.4027 8.87711 12.628 9.59506 13.1279 10.6512C10.5446 10.9863 9.22401 11.4911 7.0814 12.9186C6.43032 11.9573 6.22452 11.274 5.9186 9.60465Z",
    fill: "#D47835"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1395 9.54651L22.1977 3.09302L15.9186 1V7.22093C15.6554 8.81897 15.4301 9.53692 14.9302 10.593C17.5136 10.9282 18.8341 11.4329 20.9767 12.8605C21.6278 11.8992 21.8336 11.2158 22.1395 9.54651Z",
    fill: "#AF6835"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 12.8605C8.47715 12.8605 4 17.3376 4 22.8605C4 25.8408 5.30378 28.5166 7.37209 30.3487L8.70123 28.0858C7.37603 26.7421 6.55814 24.8968 6.55814 22.8605C6.55814 18.7504 9.88997 15.4186 14 15.4186C14.6872 15.4186 15.3527 15.5118 15.9845 15.6861L17.314 13.4227C16.2768 13.0585 15.1615 12.8605 14 12.8605Z",
    fill: "#D47835"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 32.8605C19.5228 32.8605 24 28.3833 24 22.8605C24 18.4992 21.208 14.79 17.314 13.4227L15.9845 15.6861C19.1311 16.5546 21.4419 19.4377 21.4419 22.8605C21.4419 26.9705 18.11 30.3023 14 30.3023C11.9263 30.3023 10.0507 29.4542 8.70123 28.0858L7.37209 30.3487C9.13658 31.9116 11.4575 32.8605 14 32.8605Z",
    fill: "#AF6835"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 30.3023C18.11 30.3023 21.4419 26.9705 21.4419 22.8605C21.4419 19.4377 19.1311 16.5546 15.9845 15.6861L8.70123 28.0858C10.0507 29.4542 11.9263 30.3023 14 30.3023Z",
    fill: "#D47835"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 15.4186C9.88997 15.4186 6.55814 18.7504 6.55814 22.8605C6.55814 24.8968 7.37603 26.7421 8.70123 28.0858L15.9845 15.6861C15.3527 15.5118 14.6872 15.4186 14 15.4186Z",
    fill: "#AF6835"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_61_1779",
    x: 0,
    y: 1,
    width: 28,
    height: 39.8605,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_61_1779"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_61_1779",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBronze);
export default __webpack_public_path__ + "static/media/bronze.0283f886b2c6060309d4a952e864a6d8.svg";
export { ForwardRef as ReactComponent };